import { FileCard } from "@circle-react-shared/EditorContentBlocks/FileCard";
import { RemoveButton } from "@circle-react-shared/EditorContentBlocks/RemoveButton";
import { useFilePreviewModal } from "@circle-react/components/shared/uikit/TipTapBlockEditor/FileExtension/FilePreviewModal";
import { NodeViewWrapper } from "@tiptap/react";
import type { MouseEventHandler } from "react";

export interface CompassAttachmentRendererProps {
  attachment: any;
  isEditable: boolean;
  isPDF: boolean;
  onDelete: MouseEventHandler<HTMLButtonElement>;
}

export const CompassAttachmentRenderer = ({
  attachment,
  isEditable,
  isPDF,
  onDelete,
}: CompassAttachmentRendererProps) => {
  const filePreviewModal = useFilePreviewModal();

  return (
    <NodeViewWrapper
      as="div"
      id="file-wrapper"
      className="group relative my-3 w-full max-w-[500px]"
    >
      {isEditable && <RemoveButton onClick={onDelete} />}
      <FileCard
        file={attachment}
        isDownloadable={attachment.is_downloadable !== false}
        previewUrl={isPDF ? attachment.image_variants?.thumbnail : undefined}
        onPreview={
          isPDF
            ? () => {
                void filePreviewModal.show({ file: attachment });
              }
            : undefined
        }
      />
    </NodeViewWrapper>
  );
};
